module.exports = __webpack_public_path__ + "media/images/landing_page/2023/webpage/majaslapa-parvaldiba-0b1ce3e22a8cdf955eebe37a70ad80f5.webp";